import {
  getOrganizationsByOrgIdOfficialTeam,
  getTeamsSearch,
} from "@aura-frontend/omnibus-az-client";
import { useQuery } from "@tanstack/react-query";

import { removeOrgPrefix } from "@/lib/utils";

export const useOfficialTeamData = (organizationId: string) => {
  const result = useQuery({
    queryKey: ["officialTeam", organizationId],
    queryFn: async () => {
      const { data: officialTeamData } =
        await getOrganizationsByOrgIdOfficialTeam({
          path: { org_id: removeOrgPrefix(organizationId!) },
        });

      if (!officialTeamData || !officialTeamData?.externalIds.length) {
        return null;
      }
      const teamExternalId = officialTeamData?.externalIds[0];

      // The visibility group is dynamic based on the team external id so we support both College Splits ID and Perfect Game
      const visibilityGroup = teamExternalId.startsWith("CSB")
        ? "COLLEGE_SPLITS_BASEBALL"
        : "PERFECT_GAME";

      const { data: teamData } = await getTeamsSearch({
        query: {
          externalId: teamExternalId,
          visibilityGroup,
        },
      });

      return {
        id: teamData?.teams[0].id ?? "",
        name: teamData?.teams[0].known_names?.[0] ?? "",
        externalId: teamExternalId,
      };
    },
    enabled: !!organizationId,
  });
  return result;
};
